import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';

import {Construct} from 'classes/construct';
import {Question} from 'classes/question';
import {ConstructListService} from './services/construct-list.service';
import { ConstructListModule } from './construct-list.module';

@Component({
  selector: 'construct-list',
  templateUrl: './construct-list.component.html',
  styleUrls: ['./construct-list.component.css'],
})
export class ConstructListComponent implements OnInit {

  @Input() private language: string;
  @Input() private varOnly: boolean = false;
  @Output() private questionRemoved: EventEmitter<Question> = new EventEmitter();
  private constructs: Array<Construct>;
  public searchTerm: string;
  public full = false;

  constructor(private router: Router,
              private constructListService: ConstructListService) {
    this.constructs = [];
  }

  public ngOnInit(): void {
    this.constructListService.getUndistributedConstructs(this.full)
      .subscribe((constructs: Array<Construct>) => {
        this.constructs = constructs;
        this.loadConstruct(this.constructs[0]);
      });
  }

  public loadConstruct(construct: Construct) {
    if (!this.full && construct && construct.questions.length == 0) {
      this.constructListService.getConstructFull(construct)
        .subscribe((constructFull: Construct) => {
          construct.questions = constructFull.questions;
          for(let i = 0; i < this.constructs.length; i++) {
            if (this.constructs[i]._id == construct._id) {
              this.constructs[i].questions = constructFull.questions;
              break;
            }
          }
        });
    }
  }

  public changeFull() {
    if (this.full) {
      this.constructListService.getUndistributedConstructs(this.full)
      .subscribe((constructs: Array<Construct>) => {
        this.constructs = constructs;
      });
    }
  }

  public addQuestionToConstruct(question: Question): void {
    let construct: Construct = this.constructs.find((_construct) => {
      return _construct._id === question.construct._id;
    });

    if (construct) {
      construct.questions.push(question);
      return;
    }

    construct = question.construct;
    construct.questions = [question];

    this.constructs.push(construct);
  }

  public get filteredConstructs(): Array<Construct> {
    const filtered = this.constructs.filter((construct) => {
      return this.filterBySearchTerm(construct) && (!this.varOnly || construct.varName);
    })
    if (!this.full && filtered[0] && filtered[0].questions.length == 0) {
      this.loadConstruct(filtered[0]);
    }
    return filtered;
  }

  private filterBySearchTerm(construct: Construct): boolean {
    if (!this.searchTerm) {
      return true;
    }

    const searchTerm: string = this.searchTerm.toLowerCase();

    if (construct.name.toLowerCase().includes(searchTerm)) {
      return true;
    }

    const foundQuestion: Question = construct.questions.find((question) => {
      return question.text[this.language].toLowerCase()
        .includes(searchTerm);
    });

    return foundQuestion ? true : false;
  }

  private removeQuestion(question: Question, construct: Construct): void { // tslint:disable-line
    // Set the construct, so the listener knows the question's parent construct
    question.construct = construct;

    const questionIndex: number = construct.questions.findIndex((_question) => {
      return _question._id === question._id;
    });

    if (questionIndex > -1) {
      construct.questions.splice(questionIndex, 1);
    }

    if (construct.questions.length === 0) {
      const constructIndex: number = this.constructs.findIndex((_construct) => {
        return _construct._id === construct._id;
      });

      if (constructIndex > -1) {
        this.constructs.splice(constructIndex, 1);
      }
    }

    this.questionRemoved.emit(question);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-details/construct-list/construct-list.component.ts